import { createFileRoute } from '@tanstack/react-router'

import { LibraryPage } from '@/features/custom-dashboards/components/library/library-page'

/**
 * The Library route (ticket 33): the browse-and-manage home for the tenant's
 * dashboards AND widgets, in two tabs. The tab is a search param (validated by
 * the parent layout's `customDashboardsSearchSchema`) so the "+ Add" menu and
 * the future sidebar entry (ticket 34) can deep-link a specific tab; absent
 * means Dashboards, the mock's resting state.
 *
 * Browsing is a read open to every role (the parent's gate); every write
 * affordance inside is Analyst+, gated where it renders (A-01: this route
 * imports the page, it does not build it).
 */
export const Route = createFileRoute('/_dashboard/custom-dashboards/library')({
	head: () => ({ meta: [{ title: 'Library | BitLyft AIR®' }] }),
	component: LibraryRoute,
})

function LibraryRoute() {
	const { tab } = Route.useSearch()
	const navigate = Route.useNavigate()

	return (
		<LibraryPage
			tab={tab ?? 'dashboards'}
			onTabChange={(next) =>
				void navigate({
					search: (prev) => ({ ...prev, tab: next }),
					replace: true,
				})
			}
		/>
	)
}
